export default __webpack_public_path__ + "static/bottom-dashboard-8504331fd39e437c714393dc789fcff0.png";